import * as React from "react";

export type SliderProps = {
    /**
     * Opacity state setter
     */
    setOpacity: React.Dispatch<React.SetStateAction<number>>;

    /**
     * Classname of slider
     */
    className?: string;
};

/**
 * Opacity slider
 * @param props Properties for opacity slider
 * @returns Slider
 */
export const OpacitySlider = (props: SliderProps): JSX.Element => {

    /**
     * Handler for the change event. Sets opacity value
     * @param e Slider input change event
     */
    const handleChange = (e) => {
        const value = e.target.value;
        props.setOpacity(value);
    };

    return (
        <div className="opacity-slider">
            <input
                title="Transparantie"
                id="slider3"
                className={props.className}
                type="range"
                min="0"
                max="100"
                step="1"
                defaultValue={100}
                onChange={(e) => (handleChange(e))}
            />
        </div>
    );
};
